import { TabStyle } from './types';
import { _remStyleSheet } from './utils/style';
const getDefInWrapperStyle = (props) => {
    const { tabWidth, headBgColor, tabLevel, extraWidth, isExtraIconV, showMaskIcon, isTabCenter } = props || {};
    return {
        overflow: 'hidden',
        width: isTabCenter ? tabWidth - extraWidth : tabWidth - 48 - extraWidth,
        backgroundColor: headBgColor,
        marginLeft: 0,
        borderTopRightRadius: tabLevel === 2 || extraWidth > 0 ? 0 : 24,
        borderTopLeftRadius: tabLevel === 2 ? 0 : 24,
        borderBottomLeftRadius: 24,
        borderBottomRightRadius: extraWidth > 0 || isExtraIconV && !showMaskIcon ? 0 : 24
    };
};
const getStickyInWrapperStyle = (props) => {
    const { tabWidth, tabLevel, extraWidth } = props || {};
    return {
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
        width: tabWidth - extraWidth - 24,
        marginLeft: 0,
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        borderBottomRightRadius: tabLevel === 2 ? 24 : 0,
        borderBottomLeftRadius: tabLevel === 2 ? 24 : 0
    };
};
const getDefInWrapperImgStyle = (props) => {
    const { tabWidth, extraWidth, isTabCenter } = props || {};
    return {
        overflow: 'hidden',
        width: isTabCenter ? tabWidth - extraWidth : '100%',
        // marginLeft: 24,
        borderRadius: 0
    };
};
const getStickyInWrapperImgStyle = (props) => {
    const { tabWidth, stickyWrapperBgColor, extraWidth } = props || {};
    return {
        overflow: 'hidden',
        backgroundColor: stickyWrapperBgColor,
        width: tabWidth - extraWidth,
        marginLeft: 0,
        borderRadius: 0
    };
};
const getTheme = (textActiveColor, textDefaultColor, isDoubleLine, subLevelTabStyles, isSticky) => {
    return {
        activeOpacity: 1,
        itemSpacing: 23.5,
        height: 44,
        titleActiveColor: textActiveColor,
        titleColor: isSticky ? '#222222' : textDefaultColor,
        anchorWidth: 31,
        anchorMaxWidth: 31,
        anchorBottom: isDoubleLine ? 6 : 3,
        anchorBgColor: textActiveColor,
        subtitleColor: isSticky ? '#222222' : textDefaultColor,
        doubleLineHeight: 54,
        subtitleActiveColor: textActiveColor,
        subtitleTextType: 'label2',
        tagBgColor: subLevelTabStyles.backgroundColor
    };
};
const getInnerWrapperStyle = (isSticky, tabStyle, props) => {
    //未吸顶时tab容器样式
    const defMap = {
        image: getDefInWrapperImgStyle(props),
        text: getDefInWrapperStyle(props)
    };
    //吸顶时tab容器样式
    const stickyMap = {
        image: getStickyInWrapperImgStyle(props),
        text: getStickyInWrapperStyle(props)
    };
    return isSticky ? stickyMap[tabStyle] : defMap[tabStyle];
};
const getBaseStyle = (props) => {
    const { 
    // tabMarginTop,
    isSticky, 
    // bottomMarginVal,
    leftMarginVal, rightMarginVal, tabStyle, tabWidth, isEdit, extraIconType, ExtraIconType, headBgColor, tabLevel, linerExtraColor, isStickyTab, isTabCenter } = props;
    return _remStyleSheet({
        tabBox: {
            display: 'flex',
            alignItems: 'center',
            // marginTop: tabMarginTop,
            // marginBottom: isSticky ? 0 : bottomMarginVal,
            marginLeft: leftMarginVal,
            marginRight: rightMarginVal
        },
        wrapperStyle: {
            // flexDirection: 'row',
            width: tabWidth,
            paddingLeft: isSticky || isTabCenter || tabStyle === TabStyle.IMG ? 0 : 24,
            paddingRight: isSticky || isTabCenter || tabStyle === TabStyle.IMG ? 0 : 24
        },
        innerWrapper: getInnerWrapperStyle(isSticky, tabStyle, props),
        tabContainerStyle: {
            paddingLeft: tabStyle === TabStyle.IMG && !isSticky ? 24 : 0,
            paddingRight: tabStyle === TabStyle.IMG ? 24 : 0
        },
        show: Object.assign(Object.assign({ position: 'relative' }, (isStickyTab ? {
            zIndex: 0
        } : {})), (isEdit ? {
            opacity: 1
        } : {
            display: 'flex',
            opacity: 1,
            zIndex: 0
        })),
        hide: Object.assign({}, (isEdit ? {
            opacity: 0
        } : {
            display: 'none',
            opacity: 0,
            zIndex: -999
        })),
        //有蒙层
        iconWrapper: {
            position: 'absolute',
            height: '100%',
            flexDirection: 'row',
            right: isSticky ? 0 : 24,
            width: extraIconType === ExtraIconType.VERTICAL ? 140 : 40,
            borderTopRightRadius: isSticky || tabLevel === 2 ? 0 : 24,
            borderBottomRightRadius: isSticky ? 0 : 24,
            overflow: 'hidden'
        },
        //无蒙层
        iconWrapperNoLiner: {
            position: 'absolute',
            height: '100%',
            right: isSticky ? 0 : 24,
            backgroundColor: isSticky ? '#FFFFFF' : headBgColor,
            width: 76,
            borderTopRightRadius: isSticky || tabLevel === 2 ? 0 : 24,
            borderBottomRightRadius: isSticky ? 0 : 24,
            overflow: 'hidden'
        },
        downIconBackground: {
            width: isSticky ? 100 : 76,
            backgroundColor: isSticky || !linerExtraColor ? '#FFFFFF' : linerExtraColor
        },
        linearBox: {
            flex: 1
        }
    });
};
export { getTheme, getBaseStyle };
